module.exports = __webpack_public_path__ + "static/Autodiscover-tool-7552aa8a6f4730acea865fd84d327224.png";